<template>
  <section id="section-notice" class="notice-section">
    <header class="notice-section__top">
      <div class="notice-section__heading">
        <h2>{{ $t('notice.title') }}</h2>
      </div>
      <form class="notice-search" @submit.prevent="applySearch">
        <label class="notice-search__field">
          <span class="sr-only">{{ $t('games.searchPlaceholder') }}</span>
          <input
            v-model.trim="searchInput"
            type="search"
            :placeholder="$t('games.searchPlaceholder')"
            autocomplete="off"
          >
          <svg class="notice-search__icon" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
            <circle cx="11" cy="11" r="7" fill="none" stroke="currentColor" stroke-width="2" />
            <path d="M16 16l5 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
          </svg>
        </label>
        <button type="submit" class="notice-search__btn">{{ $t('betting.search') }}</button>
      </form>
    </header>

    <nav class="notice-tabs" :aria-label="$t('notice.title')">
      <button
        v-for="tab in tabs"
        :key="tab.key"
        type="button"
        class="notice-tabs__item"
        :class="{ 'notice-tabs__item--active': activeTab === tab.key }"
        @click="setTab(tab.key)"
      >
        {{ tab.label }}
      </button>
    </nav>

    <div class="notice-panel">
      <p v-if="loading" class="notice-section__status">{{ $t('notice.loadingNotice') }}</p>
      <p v-else-if="loadError" class="notice-section__status notice-section__status--error">{{ loadError }}</p>
      <p v-else-if="!filteredNotices.length" class="notice-section__status">{{ $t('notice.emptyNotice') }}</p>

      <div v-else class="notice-table-wrap">
        <table class="notice-table notice-table--date-title">
          <thead>
            <tr>
              <th scope="col" class="notice-table__col-date">{{ $t('notice.colDate') }}</th>
              <th scope="col" class="notice-table__col-title">{{ $t('notice.colTitle') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="item in filteredNotices"
              :key="item.idx"
              class="notice-table__row"
            >
              <td class="notice-table__col-date">{{ formatNoticeDate(item.regdate) }}</td>
              <td class="notice-table__col-title">
                <button
                  type="button"
                  class="notice-table__title"
                  @click="openDetail(item.idx)"
                >
                  {{ item.title }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</template>

<script>
import { SystemService } from '@/services'
import { formatDateTime } from '@/utils/format'

export default {
  name: 'BlackGoldNoticePage',
  data () {
    return {
      loading: false,
      loadError: '',
      notices: [],
      total: 0,
      searchInput: '',
      searchQuery: '',
      activeTab: 'notice',
      tabs: [
        { key: 'notice', label: this.$t('notice.tabNotice'), type: 1 },
        { key: 'popup', label: this.$t('notice.tabPopup'), type: 2 }
      ]
    }
  },
  computed: {
    activeType () {
      const tab = this.tabs.find(item => item.key === this.activeTab)
      return tab ? tab.type : 1
    },
    filteredNotices () {
      if (!this.searchQuery) return this.notices
      const q = this.searchQuery.toLowerCase()
      return this.notices.filter(item => String(item.title || '').toLowerCase().indexOf(q) !== -1)
    }
  },
  mounted () {
    this.loadNotices()
  },
  methods: {
    reload () {
      this.loadNotices()
    },
    applySearch () {
      this.searchQuery = this.searchInput
    },
    setTab (key) {
      if (this.activeTab === key) return
      this.activeTab = key
      this.loadNotices()
    },
    formatNoticeDate (value) {
      const formatted = formatDateTime(value)
      if (formatted === '-') return formatted
      return formatted.split(' ')[0]
    },
    openDetail (idx) {
      this.$emit('open-detail', idx)
    },
    async loadNotices () {
      this.loading = true
      this.loadError = ''
      try {
        const res = await SystemService.getNoticeList(0, 100, this.activeType)
        if (res.data && res.data.code === 0 && res.data.data) {
          this.notices = Array.isArray(res.data.data.list) ? res.data.data.list : []
          this.total = Number(res.data.data.total) || this.notices.length
        } else {
          this.notices = []
          this.total = 0
          this.loadError = this.$t('notice.errorNotice')
        }
      } catch (err) {
        this.notices = []
        this.total = 0
        this.loadError = this.$t('notice.errorNotice')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
